/** CRM tab navigation (F3-I). */
import { For } from "solid-js";
import { Link } from "@tanstack/solid-router";
import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import { useI18n } from "@/providers/i18n-provider";

// Static descriptors: `t()` is called in the JSX so the text REACTS
// to the language change (i18n:reactivity gotcha — t() in setup freezes).
const TABS: { to: string; label: MessageDescriptor }[] = [
  { to: "/crm", label: msg`Pipeline` },
  { to: "/crm/segments", label: msg`Segments` },
  { to: "/crm/templates", label: msg`Templates` },
];

export function CrmTabs() {
  const { t } = useI18n();
  return (
    <nav class="mb-4 flex gap-1 border-b border-border" data-testid="crm-tabs">
      <For each={TABS}>
        {(tab) => (
          <Link
            to={tab.to}
            activeOptions={{ exact: true }}
            class="border-b-2 border-transparent px-3 py-2 text-sm font-semibold text-muted-foreground hover:text-foreground [&.active]:border-accent [&.active]:text-accent"
            activeProps={{ class: "active" }}
          >
            {t(tab.label)}
          </Link>
        )}
      </For>
    </nav>
  );
}
